import Connections from '../../connections';
import {
  action, observable,
} from 'mobx';
import { ICustomerServiceStore, CustomerServiceDay } from '../storeInterfaces/customerServiceStoreInterface';
import { getWorkingHours } from '../../axios/customerServiceRequests';
import { cloneDeep } from 'lodash';
import { convertCountriesToISOCodeString } from '../../constants/countries';
import { ICountry } from '../storeInterfaces/authInterface';

export class CustomerServiceStore implements ICustomerServiceStore {

  @observable workingHours: CustomerServiceDay[] = [];

  @observable loading = false;

  @action
  public async getWorkingHours(countries: ICountry[]) {
    try {
      this.loading = true;
      const availableCountries = convertCountriesToISOCodeString(countries);

      const params: any = {
        availableCountries,
      };
      const config = {
         params,
      };

      const response = await Connections.wadiDeglaAxios.httpGet(getWorkingHours, config);
      this.workingHours = response.data;
      this.workingHours.forEach(slot => {
        slot.isOpen = (!!slot.startTime && !!slot.endTime)
      })
    } catch (error) {
      console.log(error);
      Promise.reject(error);
    } finally {
      this.loading = false;
    }
  }

  @action.bound
  public async updateWorkingHours(workingHours: CustomerServiceDay[]) {
    try {
      const data = cloneDeep(workingHours);
      data.forEach(slot => {
        delete slot.day;
        delete slot.isOpen;
        delete slot.createdAt;
        delete slot.updatedAt;
      })  
      return Connections.wadiDeglaAxios.httpPut(getWorkingHours, {
        workingHours: data
      });
    } catch (error) {
      console.log(error);
      Promise.reject(error);
    }
  }

}
